import { render, staticRenderFns } from "./SiteChangeRequest.vue?vue&type=template&id=04914c2c&scoped=true&lang=pug"
import script from "./SiteChangeRequest.vue?vue&type=script&lang=js"
export * from "./SiteChangeRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04914c2c",
  null
  
)

export default component.exports